import { Link } from "react-router-dom";
import { FaSignInAlt, FaSignOutAlt, FaUser, FaDollarSign, FaList, FaHome, FaTimes, FaCog } from 'react-icons/fa'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { logout, reset } from '../../features/auth/authSlice'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, NavLink } from 'react-router-dom'
import { closeMenu, toggleMenu } from '../../features/utils/menuSlice';
import logo from '../../assets/budget_logo_b.svg';

const Aside = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)

    const showMenu = useSelector((state) => state.menuShow.value);
    const onLogout = () => {
        dispatch(logout())
        dispatch(reset())
        navigate('/')
        dispatch(closeMenu())
    }

    return (
    <>
        <div className={`${showMenu ? 'g-sidenav-show ' : ''}`}>
            <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-radius-lg fixed-start ms-2  bg-white my-2" id="sidenav-main">
                <div className="sidenav-header">
                    {!showMenu ? 
                    (
                        <>
                        <div className="navbar-brand px-4 py-3 m-0 border boder-bottom-1" role="button" onClick={()=> dispatch(closeMenu())}>
                            <FaTimes className="mr-1" />
                            <span className="ms-1 text-sm text-dark"> Close</span>
                        </div>
                        </>
                    ):(
                        <>
                        <NavLink className="d-flex align-items-center navbar-brand px-4 py-3 m-0 border boder-bottom-1" to={`/`} onClick={()=> dispatch(closeMenu())}>
                            <img src={logo} alt="Budget" style={{ height: '28px' }} />
                        </NavLink>
                        </>
                    )}
                </div>
                
                <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
                <ul className="navbar-nav">
                    {!showMenu && !user && 
                    <li className="nav-item">
                        <NavLink className="nav-link text-dark" to={`/`} onClick={()=> dispatch(closeMenu())}>
                            <span className="ms-1 text-sm text-dark"> Home</span>
                        </NavLink>
                    </li>
                    }
                    <li className="nav-item">
                    <NavLink className="nav-link text-dark" to={`${user ? '/dashboardPrivate' : '/dashboard'}`} onClick={()=> dispatch(closeMenu())}>
                        <FaHome className="me-1" />
                        <span className="nav-link-text ms-1">Dashboard</span>
                    </NavLink>
                    </li>
                    <li className="nav-item">
                    {user && <NavLink className="nav-link text-dark" to='/note-spese/shared' onClick={()=> dispatch(closeMenu())}>
                        <FaList className="me-1" />
                        <span className="nav-link-text ms-1">Expense list</span>
                    </NavLink>}
                    </li>
                </ul>
                {user && (
                <>
                {/* <h6 className="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6 mt-3 mb-1">Settings</h6> */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                    <NavLink className="nav-link text-dark" to='/profile' onClick={()=> dispatch(closeMenu())}>
                        <FaCog className="me-1" />
                        <span className="nav-link-text ms-1">Settings</span>
                    </NavLink>
                    </li>
                </ul>
                </>
                )}
                </div>

                <div className="sidenav-footer position-absolute w-100 bottom-0 ">
                    <div className="mx-3">
                    {user ? (
                        <button className="dashboard-btn-secondary mt-4 w-100" onClick={onLogout}>
                            <FaSignOutAlt /> Logout
                        </button>
                    ) : (
                        <>
                        <NavLink to='/login' className="dashboard-btn-secondary mt-4 w-100" type="button" onClick={()=> dispatch(closeMenu())}>
                            Login
                        </NavLink>
                        <NavLink to='/register' className="dashboard-btn-primary text-white w-100 mt-2" onClick={()=> dispatch(closeMenu())}>
                            Register
                        </NavLink>
                        </>
                    )}
                    </div>
                </div>
            </aside>
        </div>

        <div className={`${!showMenu ? "bg-secondary vh-100 w-100 opacity-5 position-absolute z-index-1"  : ''}`} onClick={() => dispatch(closeMenu())}>
        </div>
        
    </>
    )
}
export default Aside;